import React, { useState, useEffect } from 'react';
import logoImage from '../../assets/jeunessee.png';
import './index.scss';
import { Link } from 'react-router-dom';

// Hero background images (different from project images)
const HERO_IMAGES = {
  main: "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800",
  small1: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=400",
  small2: "https://images.pexels.com/photos/164504/pexels-photo-164504.jpeg?auto=compress&cs=tinysrgb&w=400",
  small3: "https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg?auto=compress&cs=tinysrgb&w=400",
};

const PROJECTS = [
  {
    id: 1,
    name: "Femme et Palmier",
    location: "Douz, Kébili",
    category: "Agriculture Durable",
    color: "#2D6A4F",
    link: "https://www.ilo.org/fr/resource/article/autonomisation-des-femmes-et-revitalisation-de-lagriculture-femme-et",
    image: "https://www.ilo.org/sites/default/files/styles/cards_4_desktop/public/2024-12/Tunisia%201_0.jpg.webp?itok=yiO-GCuS",
    description: "Autonomisation des femmes et revitalisation de l'agriculture dans le sud tunisien.",
    impact: "+45 emplois",
    year: "2021"
  },
  {
    id: 2,
    name: "Nassaem el Khir",
    location: "Siliana",
    category: "Coopérative",
    color: "#40916C",
    link: "https://www.ilo.org/fr/node/669791",
    image: "https://www.ilo.org/sites/default/files/styles/cards_4_desktop/public/2024-09/Nassaiem%20El%20khir%201.JPG.webp?itok=mduJPmBa",
    description: "Coopérative de femmes tunisiennes au service d'une agriculture durable.",
    impact: "+30 femmes",
    year: "2022"
  },
  {
    id: 3,
    name: "Laine Tej",
    location: "Jendouba",
    category: "Textile Durable",
    color: "#D4A373",
    link: "https://www.ilo.org/fr/resource/news/laine-tej-un-modele-dentreprise-inclusive-et-durable-en-tunisie",
    image: "https://www.ilo.org/sites/default/files/styles/cards_4_desktop/public/2024-12/Laine%20Tej.jpg.webp?itok=bjupbPvz",
    description: "Un modèle d'entreprise inclusive et durable en Tunisie.",
    impact: "+60 emplois",
    year: "2021"
  },
  {
    id: 4,
    name: "Dar El Ain",
    location: "Aïn Draham",
    category: "Écotourisme",
    color: "#2D6A4F",
    link: "https://www.ilo.org/fr/resource/article/dar-el-ain-une-initiative-solidaire-au-service-des-femmes-et-de",
    image: "https://www.ilo.org/sites/default/files/styles/cards_4_desktop/public/2025-02/Tunisia%20Ecotourism%202.jpg.webp?itok=1eRYpYYA",
    description: "Initiative solidaire au service des femmes et de l'écotourisme.",
    impact: "+25 jeunes",
    year: "2022"
  },
  {
    id: 5,
    name: "Complexe Nawar",
    location: "Kébili",
    category: "Patrimoine",
    color: "#CC8B65",
    link: "https://www.ilo.org/fr/resource/actualites/passerelle-entre-leconomie-sociale-et-solidaire-et-le-patrimoine-culturel",
    image: "https://www.ilo.org/sites/default/files/styles/cards_4_desktop/public/2024-09/Complexe%20Nawar%202.jpeg.webp?itok=8qyyCFnA",
    description: "Passerelle entre l'ESS et le patrimoine culturel tunisien.",
    impact: "+1000 visiteurs",
    year: "2023"
  },
];

// Result images for each result
const RESULT_IMAGES = [
  "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/164504/pexels-photo-164504.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/3184316/pexels-photo-3184316.jpeg?auto=compress&cs=tinysrgb&w=600",
];

const OBJECTIFS = [
  { num: "01", text: "De nouvelles opportunités d'emplois décents et durables sont créées pour les jeunes tunisiens à travers l'ESS." },
  { num: "02", text: "Renforcement de la résilience des organisations de l'ESS impactées par la pandémie de la COVID-19." },
  { num: "03", text: "Activation du rôle des collectivités territoriales dans l'écosystème local de l'ESS." },
];

const RESULTATS = [
  { code: "Résultat 1.1", text: "Des entreprises de l'ESS portées par des jeunes sont créées et/ou renforcées dans 7 gouvernorats cibles." },
  { code: "Résultat 1.2", text: "Les clubs de l'ESS sont opérationnels au niveau des structures locales des jeunes." },
  { code: "Résultat 1.3", text: "Les structures d'appui locales sont renforcées en matière d'accompagnement des projets ESS." },
  { code: "Résultat 2.1", text: "Les capacités organisationnelles et financières des OESS impactées par la COVID sont renforcées." },
  { code: "Résultat 2.2", text: "Les conditions nécessaires pour assurer la durabilité et la pérennité des structures soutenues par le projet sont prises en compte." },
  { code: "Résultat 3.1", text: "Les capacités des collectivités locales sont renforcées sur la promotion de l'ESS au niveau local." },
];

const PARTENAIRES = [
  { name: "Ministère de l'Économie", role: "Partenaire principal", icon: "🏛️" },
  { name: "Ministère de l'Agriculture", role: "Partenaire institutionnel", icon: "🌾" },
  { name: "Ministère de la Formation Professionnelle", role: "Partenaire institutionnel", icon: "🎓" },
  { name: "Ministère des Affaires Sociales", role: "Partenaire institutionnel", icon: "🤝" },
  { name: "UTICA", role: "Union de l'Industrie", icon: "⚙️" },
  { name: "UGTT", role: "Union des Travailleurs", icon: "✊" },
  { name: "UTAP", role: "Union de l'Agriculture", icon: "🐟" },
];

const PARTENAIRES_SOCIAUX = [
  { name: "Union Européenne", role: "Bailleur de fonds", icon: "🇪🇺" },
  { name: "Organisation Internationale du Travail", role: "Agence d'exécution", icon: "🌐" },
];

// Platform features data
const PLATFORM_FEATURES = [
  { icon: "🛍️", title: "Multi-fournisseurs", desc: "Commandez auprès de plusieurs producteurs ESS en une seule fois" },
  { icon: "📦", title: "Logistique intégrée", desc: "Gestion centralisée des livraisons et suivi en temps réel" },
  { icon: "📊", title: "Facturation unique", desc: "Une seule facture pour tous vos achats, simplifiée et claire" },
  { icon: "🤝", title: "Soutien direct", desc: "100% des bénéfices reversés aux coopératives locales" },
];

function BackToTop() {
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  useEffect(() => {
    const toggle = () => setIsButtonVisible(window.scrollY > 500);
    window.addEventListener('scroll', toggle);
    return () => window.removeEventListener('scroll', toggle);
  }, []);
  return (
    <button className={`back-top ${isButtonVisible ? 'visible' : ''}`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
      ↑
    </button>
  );
}

function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <img src={logoImage} alt="JEUN'ESS" className="nav-logo" />
        <div className={`nav-overlay ${menuOpen ? 'open' : ''}`} onClick={closeMenu}></div>
        <button className={`nav-hamburger ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span><span></span><span></span>
        </button>
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li><a href="#accueil" onClick={closeMenu}>Accueil</a></li>
          <li><a href="#projets" onClick={closeMenu}>Projets</a></li>
          <li><a href="#contexte" onClick={closeMenu}>Contexte</a></li>
          <li><a href="#objectifs" onClick={closeMenu}>Objectifs</a></li>
          <li><a href="#resultats" onClick={closeMenu}>Résultats</a></li>
          <li><a href="#plateforme" onClick={closeMenu}>Plateforme</a></li>
          <li><a href="#partenaires" onClick={closeMenu}>Partenaires</a></li>
          <li><a href="#details" onClick={closeMenu}>Détails</a></li>
        </ul>
      </div>
    </nav>
  );
}

function Hero() {
  return (
    <section className="hero" id="accueil">
      <div className="hero-bg">
        <div className="hero-bg-shape"></div>
        <div className="hero-bg-shape-2"></div>
      </div>
      <div className="hero-content">
        <div className="hero-left">
          <div className="hero-tag">
            <span>🇹🇳 Programme National</span>
            <span>🤝 Soutenu par l'UE</span>
            <span>🌱 Économie Sociale & Solidaire</span>
          </div>
          <h1>
            L'économie sociale<br />
            <span className="hero-gradient">au service de la jeunesse</span><br />
            tunisienne
          </h1>
          <p>Le projet JEUN'ESS vise la création d'emplois décents pour les jeunes dans les zones défavorisées et la transition vers l'économie formelle à travers la promotion de l'ESS.</p>
          <div className="hero-buttons">
            <Link to="/login" className="btn-primary">Connexion</Link>
            <Link to="/register" className="btn-outline">Devenir Client →</Link>
          </div>
          <div className="hero-stats-card">
            <div className="hero-stat">
              <span className="hero-stat-number">7</span>
              <span className="hero-stat-label">Gouvernorats ciblés</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">45+</span>
              <span className="hero-stat-label">Entreprises créées</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">1200+</span>
              <span className="hero-stat-label">Jeunes formés</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">2019-24</span>
              <span className="hero-stat-label">Programme</span>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-image-stack">
            <div className="hero-image-main">
              <img src={HERO_IMAGES.main} alt="JEUN'ESS Project" />
              <div className="hero-image-overlay"></div>
            </div>
            <div className="hero-image-small hero-image-1">
              <img src={HERO_IMAGES.small1} alt="Project 2" />
            </div>
            <div className="hero-image-small hero-image-2">
              <img src={HERO_IMAGES.small2} alt="Project 3" />
            </div>
            <div className="hero-image-small hero-image-3">
              <img src={HERO_IMAGES.small3} alt="Project 4" />
            </div>
            <div className="hero-floating-card">
              <span>🏆</span>
              <div>
                <strong>5 projets phares</strong>
                <small>Accompagnés par JEUN'ESS</small>
              </div>
            </div>
            <div className="hero-floating-card-2">
              <span>🌿</span>
              <div>
                <strong>100% ESS</strong>
                <small>Économie verte & solidaire</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-wave">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 64L60 69.3C120 75 240 85 360 80C480 75 600 53 720 48C840 43 960 53 1080 58.7C1200 64 1320 64 1380 64L1440 64L1440 120L1380 120C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120L0 120Z" fill="#FCFAF5"/>
        </svg>
      </div>
    </section>
  );
}

function ProjectsShowcase() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const nextProject = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex((prev) => (prev + 1) % PROJECTS.length);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const prevProject = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex((prev) => (prev - 1 + PROJECTS.length) % PROJECTS.length);
    setTimeout(() => setIsAnimating(false), 500);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % PROJECTS.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const currentProject = PROJECTS[activeIndex];

  return (
    <section className="projects" id="projets">
      <div className="container">
        <div className="projects-header">
          <span className="section-badge">Nos projets phares</span>
          <h2>Découvrez les initiatives <span className="highlight">accompagnées par JEUN'ESS</span></h2>
        </div>
        <div className="projects-showcase">
          <button className="projects-nav prev" onClick={prevProject}>←</button>
          <div className="projects-card" key={activeIndex}>
            <div className="projects-card-image">
              <img src={currentProject.image} alt={currentProject.name} />
              <div className="projects-card-overlay"></div>
              <span className="projects-card-year">{currentProject.year}</span>
            </div>
            <div className="projects-card-content">
              <span className="projects-card-category" style={{ background: currentProject.color }}>{currentProject.category}</span>
              <h3>{currentProject.name}</h3>
              <p className="projects-card-location">📍 {currentProject.location}</p>
              <p className="projects-card-desc">{currentProject.description}</p>
              <div className="projects-card-impact">
                <strong>Impact social:</strong> {currentProject.impact}
              </div>
              <a href={currentProject.link} target="_blank" rel="noopener noreferrer" className="projects-card-link">
                Explorer le projet →
              </a>
            </div>
          </div>
          <button className="projects-nav next" onClick={nextProject}>→</button>
        </div>
        <div className="projects-dots">
          {PROJECTS.map((_, idx) => (
            <button key={idx} className={`projects-dot ${idx === activeIndex ? 'active' : ''}`} onClick={() => setActiveIndex(idx)} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Contexte() {
  return (
    <section className="section contexte" id="contexte">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Contexte</span>
          <h2>Pourquoi ce projet est <span className="highlight">nécessaire</span></h2>
        </div>
        <div className="contexte-grid">
          <div className="contexte-text">
            <p><strong>Le chômage chez les jeunes diplômés</strong>, touchant particulièrement les régions intérieures, est le problème central de la Tunisie après la révolution. Au problème du chômage s'ajoute le déséquilibre régional en termes de développement économique, social et environnemental.</p>
            <p>Le Gouvernement tunisien et ses partenaires considèrent la création d'emplois décents — en particulier pour les jeunes dans les régions défavorisées — comme priorité centrale et moteur de croissance économique.</p>
            <p>Les difficultés économiques ont réduit la capacité du secteur privé à créer des emplois. La promotion de l'emploi indépendant à travers l'entrepreneuriat collectif offre un réel potentiel pour réduire le chômage des jeunes, y compris dans <strong>l'économie informelle</strong>.</p>
            <p><strong>L'économie sociale et solidaire (ESS)</strong> a été identifiée comme un secteur possédant un important potentiel de réduction des inégalités, de création d'emploi et d'inclusion sociale — voie de passage vers l'économie formelle.</p>
          </div>
          <div className="contexte-quote">
            <div className="quote-mark">"</div>
            <p>L'ESS offre un réel potentiel pour réduire significativement le chômage des jeunes, y compris au sein de l'économie informelle.</p>
            <span className="quote-source">— Stratégie nationale tunisienne</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function Objectifs() {
  return (
    <section className="section objectifs" id="objectifs">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Objectifs du projet</span>
          <h2>Ce que JEUN'ESS vise à <span className="highlight">accomplir</span></h2>
        </div>
        
        {/* Redesigned development goal banner */}
        <div className="objectif-dev-goal">
          <div className="dev-goal-ring">
            <span className="dev-goal-icon">🎯</span>
          </div>
          <div className="dev-goal-content">
            <span className="dev-goal-label">Objectif de développement</span>
            <p>Améliorer l'accessibilité des jeunes à l'emploi décent et durable au niveau régional à travers l'entrepreneuriat collectif et les mécanismes de l'ESS.</p>
          </div>
          <div className="dev-goal-decoration"></div>
        </div>

        <div className="objectifs-horizontal">
          {OBJECTIFS.map((o, i) => (
            <div className="objectif-card-horizontal" key={i}>
              <div className="objectif-card-number">{o.num}</div>
              <div className="objectif-card-text">
                <div className="objectif-card-icon">
                  {i === 0 && "💼"}
                  {i === 1 && "🛡️"}
                  {i === 2 && "🏛️"}
                </div>
                <p>{o.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Resultats() {
  return (
    <section className="section resultats" id="resultats">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Résultats attendus</span>
          <h2>Les effets <span className="highlight">concrets</span> sur le terrain</h2>
        </div>
        <div className="resultats-grid-enhanced">
          {RESULTATS.map((r, i) => (
            <div className="resultat-card-enhanced" key={i}>
              <div className="resultat-card-image">
                <img src={RESULT_IMAGES[i % RESULT_IMAGES.length]} alt={r.code} />
                <div className="resultat-card-overlay"></div>
                <span className="resultat-code-badge">{r.code}</span>
              </div>
              <div className="resultat-card-content">
                <p>{r.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Beneficiaires() {
  return (
    <section className="section beneficiaires">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Bénéficiaires</span>
          <h2>Qui est <span className="highlight">touché</span> par le projet ?</h2>
        </div>
        <div className="beneficiaires-grid">
          <div className="beneficiaire-card">
            <div className="beneficiaire-icon">👥</div>
            <h3>Les jeunes</h3>
            <p>Jeunes des zones d'intervention dans les régions défavorisées de Tunisie, avec une attention particulière pour l'employabilité des jeunes diplômés.</p>
          </div>
          <div className="beneficiaire-card">
            <div className="beneficiaire-icon">🏢</div>
            <h3>Organisations de l'ESS</h3>
            <p>Coopératives, associations et mutuelles portées par des jeunes, renforcées dans leurs capacités organisationnelles et financières.</p>
          </div>
          <div className="beneficiaire-card">
            <div className="beneficiaire-icon">🤝</div>
            <h3>Structures d'appui</h3>
            <p>Structures d'accompagnement des organisations de l'ESS au niveau local, formées et outillées pour mieux soutenir l'écosystème.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function ChiffresCles() {
  const chiffres = [
    { value: "7", label: "Gouvernorats ciblés", desc: "Bizerte, Jendouba, Béja, Siliana, Kairouan, Kébili, Gabès", icon: "📍" },
    { value: "2019-2024", label: "Durée du projet", desc: "5 ans d'action continue", icon: "📅" },
    { value: "100%", label: "Jeunes bénéficiaires", desc: "Priorité aux zones défavorisées", icon: "👥" },
    { value: "50/50", label: "Parité", desc: "Égalité femmes-hommes dans les projets", icon: "⚖️" },
  ];
  return (
    <section className="section chiffres-enhanced">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Chiffres clés</span>
          <h2>JEUN'ESS en <span className="highlight">quelques données</span></h2>
        </div>
        <div className="chiffres-horizontal-row">
          {chiffres.map((c, i) => (
            <div className="chiffre-card-horizontal" key={i}>
              <div className="chiffre-icon">{c.icon}</div>
              <div className="chiffre-value">{c.value}</div>
              <div className="chiffre-label">{c.label}</div>
              <div className="chiffre-desc">{c.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// New Platform Section - FIXED (no unused variables)
function Plateforme() {
  return (
    <section className="section plateforme" id="plateforme">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Plateforme collaborative</span>
          <h2>Une marketplace dédiée aux <span className="highlight">produits de l'ESS</span></h2>
          <p className="section-subtitle">
            JEUN'ESS lance une plateforme innovante qui connecte les coopératives tunisiennes aux consommateurs.
            Commandez auprès de plusieurs fournisseurs en une seule transaction.
          </p>
        </div>

        <div className="plateforme-showcase">
          <div className="plateforme-mockup">
            <div className="mockup-header">
              <div className="mockup-dots">
                <span></span><span></span><span></span>
              </div>
              <div className="mockup-title">JEUN'ESS Marketplace</div>
            </div>
            <div className="mockup-content">
              <div className="mockup-cart">
                <div className="cart-item">
                  <div className="cart-item-icon">🌾</div>
                  <div>Miel de Kébili - Coopérative Femme et Palmier</div>
                  <div className="cart-price">12 DT</div>
                </div>
                <div className="cart-item">
                  <div className="cart-item-icon">🧣</div>
                  <div>Écharpe en laine - Laine Tej</div>
                  <div className="cart-price">45 DT</div>
                </div>
                <div className="cart-item">
                  <div className="cart-item-icon">🏺</div>
                  <div>Poterie artisanale - Complexe Nawar</div>
                  <div className="cart-price">28 DT</div>
                </div>
                <div className="cart-total">
                  <span>Total (3 fournisseurs)</span>
                  <span className="total-price">85 DT</span>
                </div>
              </div>
              <div className="mockup-badge">Commande multi-fournisseurs • 1 facture • Livraison groupée</div>
            </div>
          </div>

          <div className="plateforme-features">
            {PLATFORM_FEATURES.map((feature, i) => (
              <div className="platform-feature-card" key={i}>
                <div className="feature-icon">{feature.icon}</div>
                <h4>{feature.title}</h4>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="plateforme-cta">
          <div className="cta-content">
            <h3>Prêt à soutenir l'économie sociale ?</h3>
            <p>Rejoignez la plateforme JEUN'ESS et découvrez des produits authentiques de toutes les régions de Tunisie.</p>
            <div className="cta-buttons">
              <Link to="/login" className="btn-primary">Connexion</Link>
              <Link to="/register" className="btn-outline-dark">Rejoindre comme client</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function PartenairesSection() {
  return (
    <section className="section partenaires" id="partenaires">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Partenaires institutionnels</span>
          <h2>Une mobilisation <span className="highlight">nationale et internationale</span></h2>
        </div>
        <div className="partenaires-bailleurs">
          {PARTENAIRES_SOCIAUX.map((p, i) => (
            <div className="bailleur-card" key={i}>
              <div className="bailleur-icon">{p.icon}</div>
              <div className="bailleur-info">
                <h4>{p.name}</h4>
                <span>{p.role}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="partenaires-grid">
          {PARTENAIRES.map((p, i) => (
            <div className="partenaire-card" key={i}>
              <div className="partenaire-icon">{p.icon}</div>
              <h4>{p.name}</h4>
              <span className="partenaire-role">{p.role}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Details() {
  return (
    <section className="section details" id="details">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Financement & durée</span>
          <h2>Informations <span className="highlight">clés du projet</span></h2>
        </div>
        <div className="details-grid">
          <div className="detail-card">
            <div className="detail-icon">🇪🇺</div>
            <h3>Bailleur de fonds</h3>
            <p>Union Européenne</p>
          </div>
          <div className="detail-card">
            <div className="detail-icon">🌐</div>
            <h3>Agence d'exécution</h3>
            <p>Organisation Internationale du Travail (OIT)</p>
          </div>
          <div className="detail-card">
            <div className="detail-icon">📅</div>
            <h3>Durée</h3>
            <p>1 septembre 2019 — 31 août 2024</p>
          </div>
          <div className="detail-card">
            <div className="detail-icon">🔖</div>
            <h3>Référence</h3>
            <p>TUN/18/06/EUR</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <img src={logoImage} alt="JEUN'ESS" className="footer-logo" />
          <p>© Organisation Internationale du Travail (OIT) — Projet JEUN'ESS (TUN/18/06/EUR)</p>
          <div className="footer-links">
            <a href="https://www.ilo.org/fr/projects-and-partnerships/projects/projet-jeuness-promotion-de-leconomie-sociale-et-solidaire-et-creation" target="_blank" rel="noopener noreferrer">
              Site officiel JEUN'ESS →
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function Landing() {
  return (
    <>
      <Nav />
      <Hero />
      <ProjectsShowcase />
      <Contexte />
      <Objectifs />
      <Resultats />
      <Beneficiaires />
      <ChiffresCles />
      <Plateforme />
      <PartenairesSection />
      <Details />
      <Footer />
      <BackToTop />
    </>
  );
}

const LandingWithWrapper = () => <><Landing /></>;
export default LandingWithWrapper;